import { createApiAction } from '@app/packages/api/utils'
import type { ApiAvailableTime } from '@app/packages/api/v2/types/entities'
import type { AvailableTimesPutRequest } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

/** A sitter's own schedule is read by id; a shared one by the token the link carries. */
export const getAvailableTimes = (owner: { type: 'id'; value: string } | { type: 'token'; value: string }) =>
  createApiAction('getAvailableTimes', dispatch =>
    dispatch<{ data: ApiAvailableTime[] }>({
      method: 'GET',
      endpoint: v2Path('/api/v2/available_times', owner.type === 'id' ? { user_id: owner.value } : { token: owner.value }),
    })
  )

export const putAvailableTimes = (request: AvailableTimesPutRequest) =>
  createApiAction('putAvailableTimes', dispatch =>
    dispatch<{ data: ApiAvailableTime[] }>({ method: 'PUT', endpoint: '/api/v2/available_times', body: JSON.stringify(request) })
  )
